// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var Device =
/** @class */
function () {
  /**
   * Constructs a new instance of the Device class
   */
  function Device() {
    // don't attempt to fingerprint browsers
    this.id = "browser"; // Device type is a dimension in our data platform
    // Setting it to 'Browser' allows to separate client and server dependencies/exceptions

    this.deviceClass = "Browser";
  }

  return Device;
}();

export { Device };